import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import { Welcome } from '@swf/help';

import styles from './Search.scss';
import SearchBar from './components/SearchBar/SearchBar';

interface Props {
  showTitle?: boolean;
}

const Search: React.FC<Props> = ({ showTitle }) => (
  <section className={showTitle ? styles.homeContainer : styles.container}>
    <div className={styles.inner}>
      {showTitle && (
        <div className={styles.searchHeader}>
          <Welcome />
        </div>
      )}
      <SearchBar />
    </div>
  </section>
);

export const SearchSkeleton = ({ showTitle }: Props) => (
  <section className={showTitle ? styles.homeContainer : styles.container}>
    <div className={styles.inner}>
      {showTitle && (
        <div className={styles.searchHeader}>
          <Skeleton className={styles.centered} variant="rectangular" height={40} width={350} />
        </div>
      )}
      <Skeleton className={styles.searchSkeleton} variant="rectangular" height={44} />
    </div>
  </section>
);
export default Search;
